import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FeatureFlagsService } from '~modules/administration/feature-flags.service';


@Directive({
  selector: '[appFeatureFlag]',
  standalone: true
})
export class FeatureFlagDirective implements OnDestroy {
  private subscription?: Subscription;

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly featureFlagsService: FeatureFlagsService
  ) {}

  @Input()
  set appFeatureFlag(flagKey: string) {
    this.subscription?.unsubscribe();
    this.subscription = this.featureFlagsService.isEnabled(flagKey).subscribe((enabled) => {
      this.viewContainer.clear();
      if (enabled) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
